import React from 'react';
import { useNavigate } from 'react-router-dom';
import { config } from '../config/env';
import { useAuthorization } from '@/features/auth/hooks';
import { useShellI18n } from '@/features/language/useI18n';

export const AppsPage: React.FC = () => {
  const navigate = useNavigate();
  const { filterServices } = useAuthorization();
  const embeddedServices = filterServices(config().EMBEDDED_SERVICES || []);
  const { t } = useShellI18n();

  return (
    <section className="page-shell">
      <div className="page-hero">
        <h1 className="page-title">{t('Applications')}</h1>
        <p className="page-subtitle">{t('Embedded tools run in this portal with shared authentication and consent context.')}</p>
      </div>

      <div className="service-grid">
        {embeddedServices.map((service) => (
          <article
            key={service.id}
            className="service-card"
            onClick={() => navigate(`/apps/${service.id}`)}
            role="button"
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                navigate(`/apps/${service.id}`);
              }
            }}
          >
            <div className="service-head">
              <h2 className="service-name">{service.name}</h2>
              <span className="pill">{service.type}</span>
            </div>
            <p className="meta">{t('Launch this application inside the unified portal workspace.')}</p>
            <div className="service-url">{service.url}</div>
          </article>
        ))}

        {embeddedServices.length === 0 && (
          <div className="empty-state">
            {t('No applications configured in `EMBEDDED_SERVICES`.')}
          </div>
        )}
      </div>
    </section>
  );
};
